import React from 'react';
import { Flex, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import LabelBadge from 'components/labels/LabelBadge';

// Read-only row of label chips (RAT-1689/1690). Shared by the merchant detail
// page and the merchant list's Labels column so the two can't drift: same
// overflow rule, same empty text, same chip.
//
// Overflow collapses to "+N" with a tooltip naming the hidden ones, rather than
// wrapping - a merchant with eight labels must not push a table row to three
// lines.
const LabelChipList = ({
  labels,
  max = 3,
  size = 'sm',
  emptyText = 'No labels',
}) => {
  const list = labels || [];

  if (!list.length) {
    return (
      <Text color="gray.400" fontSize="sm">
        {emptyText}
      </Text>
    );
  }

  const visible = list.slice(0, max);
  const hidden = list.slice(max);

  return (
    <Flex align="center" gap="6px" wrap="nowrap" maxW="100%">
      {visible.map((label) => (
        <LabelBadge key={label.id} label={label} size={size} />
      ))}
      {hidden.length > 0 && (
        <Tooltip
          label={hidden.map((label) => label.name).join(', ')}
          hasArrow
          placement="top"
        >
          <Text
            fontSize="xs"
            fontWeight="600"
            color="gray.500"
            whiteSpace="nowrap"
            cursor="default"
          >
            +{hidden.length}
          </Text>
        </Tooltip>
      )}
    </Flex>
  );
};

LabelChipList.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      color: PropTypes.string,
    }),
  ),
  max: PropTypes.number,
  size: PropTypes.string,
  emptyText: PropTypes.string,
};

export default LabelChipList;
